import { PureComponent } from "react";

import HotdogHeaderComponent from "/components/enhancements/decorators/hotdog-header/hotdog-header-component";
import DirectoryHeaderContentComponent from "../directory-header-content/directory-header-content-component";

import { StyledDirectoryHeaderComponent } from "./directory-header-component.scss";

export default class DirectoryHeaderComponent extends PureComponent {
  render() {
    const { hotDogColor, textColor, title, subtitle, searchConfig, searchValue, onSearchChange, img } = this.props;
    return (
      <StyledDirectoryHeaderComponent className="directory-header-component-wrapper">
        <HotdogHeaderComponent
          className="directory-header-component"
          backgroundColor="light-grey"
          hotdogColor={hotDogColor}
        >
          <div className="image-container">
            <img src={img} />
          </div>

          <DirectoryHeaderContentComponent
            title={title}
            subtitle={subtitle}
            textColor={textColor}
            searchConfig={searchConfig}
            searchValue={searchValue}
            onSearchChange={onSearchChange}
          />
        </HotdogHeaderComponent>
      </StyledDirectoryHeaderComponent>
    );
  }
}
